var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2903 2.54032C11.2903 3.94456 10.1542 5.08065 8.75 5.08065C7.34577 5.08065 6.20968 3.94456 6.20968 2.54032C6.20968 1.13609 7.34577 0 8.75 0C10.1542 0 11.2903 1.13609 11.2903 2.54032ZM14.9597 0C13.5554 0 12.4194 1.13609 12.4194 2.54032C12.4194 3.94456 13.5554 5.08065 14.9597 5.08065C16.3639 5.08065 17.5 3.94456 17.5 2.54032C17.5 1.13609 16.3639 0 14.9597 0ZM2.54032 0C1.13609 0 0 1.13609 0 2.54032C0 3.94456 1.13609 5.08065 2.54032 5.08065C3.94456 5.08065 5.08065 3.94456 5.08065 2.54032C5.08065 1.13609 3.94456 0 2.54032 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.68fff0c786fed2a2359d95a8c3456271.svg";
export { ForwardRef as ReactComponent };